import React, { useEffect, useMemo, useState } from 'react';
import axios from '../../axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import { makeStyles } from '@material-ui/core/styles';
import Spinner from 'react-spinkit';
import Backdrop from '@material-ui/core/Backdrop';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  Input,
  Label,
  CardBody,
  Button,
  Table,
  FormFeedback,
} from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Divider } from '@material-ui/core';
import { styled } from '@mui/system';
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  dialogpaper: {
    width: '1200px',
  },
}));

const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: '#3468C0',
  color: '#yourCustomTextColor',
  '&:hover': {
    backgroundColor: '#2c3e50',
  },
});

function DepartmentMaster() {
  const [tokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ',
  );
  const pages = [5, 10, 15, 20, 25];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);

  const [Department, setDepartment] = useState([]);
  const [dailoa1, setdailoa1] = useState(false);
  const classes = useStyles();
  const [edit, setedit] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [modal, setModal] = useState(false);
  const [sweetAlert, setSweetAlert] = useState({
    message: '',
    type: 'success',
  });
  const [initialValue] = useState({
    DepartmentId: 0,
    DepartmentCode: '',
    DepartmentDescription: '',
  });

  const formikValidation = useFormik({
    initialValues: initialValue,
    validationSchema: Yup.object({
      DepartmentDescription: Yup.string()
        .required('Enter Desingation Description')
        .max(50, 'Cannot contain more than 50 Characters'),
    }),
    onSubmit: values => {
      InsertDepartmentData(values);
    },
  });

  useEffect(() => {
    GetAllDepartment();
  }, []);

  const GetAllDepartment = async () => {
    try {
      setdailoa1(true);
      const res = await axios.instance.get(`Department/GetAllDepartment`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setDepartment(res.data);
    } catch (e) {
      console.log('Error', e.message);
    }
    setdailoa1(false);
  };

  const InsertDepartmentData = async values => {
    try {
      setdailoa1(true);
      await axios.instance.post(
        `Department/InsertDepartment`,
        {
          ...values,
          OpType: edit ? 'edit' : 'new',
          UserId: sessionStorage.getItem('Userid'),
          [edit ? 'ModifyDate' : 'CreatedDate']: new Date(),
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      );
      setSweetAlert({
        message: `Department ${edit ? 'Updated' : 'Added'} Successfully`,
        type: 'success',
      });
      GetAllDepartment();
      handleModalClose();
    } catch (e) {
      console.log(e.message, e.response ? e.response.data : e.message);

      setSweetAlert({
        message: e.response ? e.response.data : 'Something went wrong', // Correct Axios error handling
        type: 'warning',
      });
    }
    setdailoa1(false);
  };

  const handleDelete = async () => {
    try {
      setdailoa1(true);
      await axios.instance.post(
        `Department/InsertDepartment`,
        {
          DepartmentId: deleteId,
          OpType: 'Delete',
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      );
      setSweetAlert({
        message: `Department Deleted Successfully`,
        type: 'success',
      });
      GetAllDepartment();
      setDeleteId(null);
    } catch (e) {
      console.log(e.message, e.response ? e.response.data : e.message);

      setSweetAlert({
        message: e.response ? e.response.data : 'Something went wrong', // Correct Axios error handling
        type: 'warning',
      });
    }
    setdailoa1(false);
  };

  const filteredDepartment = useMemo(() => {
    return Department.slice(page * rowsperpage, (page + 1) * rowsperpage);
  }, [Department, page, rowsperpage]);

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  const handleModalClose = () => {
    setModal(false);
    formikValidation.resetForm();
    setedit(false);
  };

  const handleModalOpen = () => {
    setModal(true);
  };

  const handleEditClick = data => {
    formikValidation.setValues(data);
    setedit(true);
    handleModalOpen();
  };

  return (
    <React.Fragment>
      <div className="page-content" style={{ backgroundColor: 'inherit' }}>
        <div className="">
          <Row>
            <Col xs="12">
              <h6 className="titleviewinspections">Department Master</h6>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end align-items-center mt-3">
                    <Col
                      xl={12}
                      className="d-flex justify-content-end gap-2 align-items-center"
                    >
                      <CustomButton
                        variant="contained"
                        onClick={handleModalOpen}
                        size="small"
                      >
                        Add Department
                      </CustomButton>
                    </Col>
                  </div>
                  <div className="Tabelinspections">
                    <TableContainer>
                      <Table className="InspectionTbls">
                        <TableHead>
                          <TableRow>
                            <TableCell>Department Code </TableCell>
                            <TableCell align="left">
                              Department Description
                            </TableCell>
                            <TableCell>Edit</TableCell>
                            <TableCell>Delete</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Department.length != 0 ? (
                            filteredDepartment.map(data => (
                              <TableRow key={data.DepartmentId}>
                                <TableCell style={{ textAlign: 'left' }}>
                                  {data.DepartmentCode}
                                </TableCell>
                                <TableCell style={{ textAlign: 'left' }}>
                                  {data.DepartmentDescription}
                                </TableCell>
                                <TableCell align="left">
                                  <IconButton size="small">
                                    <EditIcon
                                      fontSize="small"
                                      color="primary"
                                      onClick={() => {
                                        handleEditClick(data);
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                                <TableCell align="left">
                                  <IconButton size="small">
                                    <DeleteIcon
                                      color="error"
                                      fontSize="small"
                                      onClick={() => {
                                        setDeleteConfirm(true);
                                        setDeleteId(data.DepartmentId);
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableCell align="left">NO Data Found</TableCell>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TablePagination
                      component="div"
                      rowsPerPageOptions={pages}
                      count={Department.length}
                      rowsPerPage={rowsperpage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={handleModalClose} size="md">
            <ModalHeader toggle={handleModalClose} tag="h4">
              {edit ? 'Edit' : 'Add'} Department
            </ModalHeader>
            <ModalBody>
              <Row>
                {edit && (
                  <Col lg="12">
                    <Label for="basicpill-firstname-input1">
                      Department Code
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={formikValidation.values.DepartmentCode}
                      disabled
                    />
                  </Col>
                )}
                <Col lg="12">
                  <Label for="basicpill-firstname-input1">
                    Department Description
                  </Label>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    name="DepartmentDescription"
                    value={formikValidation.values.DepartmentDescription}
                    onChange={formikValidation.handleChange}
                    onBlur={formikValidation.handleBlur}
                    invalid={
                      !!(
                        formikValidation.errors.DepartmentDescription &&
                        formikValidation.touched.DepartmentDescription
                      )
                    }
                  />
                  {formikValidation.touched.DepartmentDescription &&
                    formikValidation.errors.DepartmentDescription && (
                      <FormFeedback type="invalid">
                        {formikValidation.errors.DepartmentDescription}
                      </FormFeedback>
                    )}
                </Col>
              </Row>
              {/* <ModalFooter> */}
              <div className="d-flex justify-content-center ">
                <Button
                  color="primary"
                  style={{ backgroundColor: '#3468C0', color: 'white' }}
                  onClick={() => {
                    formikValidation.submitForm();
                  }}
                >
                  {edit ? 'Update' : 'Save'}
                </Button>
              </div>
              {/* </ModalFooter> */}
            </ModalBody>
          </Modal>
        </div>
      </div>

      <Backdrop open={dailoa1} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>

      {deleteConfirm && (
        <SweetAlert
          title="Are You Sure?"
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          confirmBtnBsStyle="success"
          showConfirm={true}
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          confirmBtnText="Yes,delete it!"
          showCancel={true}
          warning
          onConfirm={() => {
            handleDelete();
            setDeleteConfirm(false);
          }}
          onCancel={() => {
            setDeleteConfirm(false);
            setDeleteId(null);
            // setdeleted(false);
          }}
        >
          <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
        </SweetAlert>
      )}

      {sweetAlert.message && (
        <SweetAlert
          title={sweetAlert.message}
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          type={sweetAlert.type}
          onConfirm={() => {
            setSweetAlert({
              message: '',
              type: 'success',
            });
          }}
        ></SweetAlert>
      )}
    </React.Fragment>
  );
}

export default DepartmentMaster;
